<template>
    <div class="account-page-padding">
        <h1>Profile</h1>
        <h3>Update Contact Information</h3>
        <form class="authorization-form contact-change" @submit.prevent="submitForm()">
            <!-- removing until ERP D2C changes are completed/merged
            <div class="field-state input-folder">
                <div class="input-folder--input">
                    <InputText 
                        id="username" v-model="form.username"
                        :class="{'invalid-state-input': form.errors.username != null}"
                        placeholder=" "
                        fluid
                    />
                    <label for="username" :class="{'invalid-state': form.errors.username}">
                        <p>Name *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.username">{{ form.errors.username }}</p></div>
            </div> -->
            <div class="field-state input-folder">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            id="email" v-model="form.email"
                            :class="{'invalid-state-input': form.errors.email != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="email" :class="{'invalid-state': form.errors.email}">
                            <p>Email *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.email">{{ form.errors.email }}</p></div>
                </div>
            </div>

            <div class="field-state input-folder phone-input">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <PrimeInputMask 
                            mask="(999) 999-9999"
                            id="phone_number" v-model="form.phone_number"
                            :class="{'invalid-state-input': form.errors.phone_number != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="phone_number" :class="{'invalid-state': form.errors.phone_number}">
                            <p>Phone Number</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.phone_number">{{ form.errors.phone_number }}</p></div>
                </div>
            </div>
            <RothcoCta id="submit" type="submit" class="primary" aria-label="Submit Contact Info Change" :disabled="form.processing">
                Submit
            </RothcoCta>
            <div v-if="updateSuccessful === true" class="field-state">
                <div class="notification notification-success">
                    <p class="paragraph-details"><strong>Contact Information Updated!</strong></p>
                </div>
            </div>
        </form>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, inject } from "vue";
    import { useForm } from "@/helpers/composables/useForm";
    import { string, object } from 'yup';
    // import { route } from "ziggy-js";
    import { router } from '@inertiajs/vue3'
    import NProgress from "nprogress";
    import RothcoCta from "@/components/RothcoCta.vue";
    import InputText from "primevue/inputtext";
    let props = defineProps({
        user: {
            type: Object,
            default(){
                return {}
            }
        }
    });

    let route = inject('route');
    let validateEmail = (value) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
            return true
        } else {
            return false;
        }
    }
    const form = useForm({
        useInertia: false,
        inertiaAlias: "ChangeContactInfo",
        schema: object({
            // removing until ERP D2C changes are completed/merged
            // username: string().required('Username is required.').default(props.user.username),
            email: string().required('Email is required').test({
                name: 'email',
                message: 'Email Address is invalid',
                test: (value) => {
                    return validateEmail(value);
                }
            }).default(props.user.email),
            phone_number: string().default(props.user.phone_number),
        })
    });
    
    const updateSuccessful = ref(false);
    let canSubmitForm = computed(()=>{
        return !Object.keys(form.errors).length;
    });
    let submitForm = () => {
        if(form.processing) return;

        if(canSubmitForm.value){
            form.put(
                route("endpoint.user.update", props.user.user_id),
                form.transform((data)=>{
                    delete data['username']; // removing until ERP D2C changes are completed/merged
                    return {
                        user: {
                            ...data
                        }
                    }
                }),
                {
                    beforeFetch: () => {
                        NProgress.start();
                        updateSuccessful.value = false;
                    },
                    afterFetch: (ctx) => {
                        if (NProgress.isStarted()) {
                            NProgress.done();
                        }
                        updateSuccessful.value = true;
                        router.reload({ only: ['user'] });
                    },
                    onFetchError: (err)=>{
                        if (NProgress.isStarted()) {
                            NProgress.done();
                        }
                    }
                }
            )
        }
    };
</script>
<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";
.contact-change {
    @media (min-width: $breakpoint-desktop) {
        width: 50%;
    }
}
</style>
